import { useHistory, useLocation } from 'react-router';

import { Anchor, Button, Icon } from '@zillow/constellation-10';
import { IconCloseOutline, IconSearchFilled } from '@zillow/constellation-icons';

import QueryConstants from '../../../constants/QueryConstants';

import EmptyState from '../../../components/EmptyState';

export const NoSearchResults = ({
  showArchived,
  onRemoveSearchTextClick,
}: {
  showArchived: boolean;
  onRemoveSearchTextClick: (value: string) => void;
}) => {
  const history = useHistory();
  const location = useLocation();

  // Add postingPath query param to open the add property modal
  const handleAddPropertyClick = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set(QueryConstants.POSTING_PATH, 'true');
    history.replace({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };

  return (
    <EmptyState
      icon={<Icon render={<IconSearchFilled />} size="md" css={{ color: 'icon.subtle' }} />}
      heading="No properties found"
      headingLevel={3}
      body={
        <>
          No properties match the current filters.
          {!showArchived && (
            <>
              {' '}
              Would you like to <Anchor onClick={handleAddPropertyClick}>post a listing</Anchor>?
            </>
          )}
        </>
      }
      actions={
        <Button
          tone="brand"
          emphasis="outlined"
          size="sm"
          icon={<IconCloseOutline />}
          iconPosition="end"
          onClick={() => onRemoveSearchTextClick('')}
        >
          Remove search
        </Button>
      }
      useCard={false}
      align="center"
    />
  );
};
